import { Link, useLocation } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import Logo from "../images/AE-Hero.svg";

const Footer = () => {
    const location = useLocation();
    const isHomePage = location.pathname === '/';

    const scrollNavItems = [
        { id: 'hero', label: 'Home', to: '/', scrollTo: 'hero' },
        { id: 'about', label: 'About Us', to: '/#about', scrollTo: 'about' },
        { id: 'services', label: 'Our Services', to: '/#services', scrollTo: 'services' },
        { id: 'contact', label: 'Contact Us', to: '/#contact', scrollTo: 'contact' },
    ];

    const linkClass = "text-gray-400 hover:text-yellow-500 transition-colors duration-300";

    return (
        <footer id="footer" className="footer dark-background bg-gray-900 text-white">
            <div className="footer-top bg-gray-800 py-16">
                <div className="container mx-auto px-4">
                    <div className="flex flex-wrap -mx-4">
                        {/* About Section */}
                        <div className="w-full lg:w-1/2 md:w-1/2 px-4 mb-8">
                            <div className="footer-about">
                                <Link to="/" className="logo flex items-center">
                                    <div className="h-16 w-16 md:h-20 md:w-20 lg:h-24 lg:w-24 rounded-full overflow-hidden bg-white flex items-center justify-center p-1">
                                        <img
                                            src={Logo}
                                            alt="Alternative Energy"
                                            className="max-h-full max-w-full object-contain"
                                        />
                                    </div>
                                </Link>
                                <div className="footer-contact pt-6">
                                    <p className="text-gray-300">Lot 810 Cnr Lifahlawane St &, Shiselweni Ave</p>
                                    <p className="text-gray-300">Matsapha M202, Eswatini</p>
                                    <p className="mt-4 text-gray-300">
                                        <strong className="font-semibold text-white">Phone:</strong>
                                        <span className="ml-2">+268 2518 5414</span>
                                        <span className="ml-2">+268 2518 7424</span>
                                    </p>
                                    <p className="text-gray-300">
                                        <strong className="font-semibold text-white">Email:</strong>
                                        <span className="ml-2">info@alternative.co.sz</span>
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Quick Links */}
                        <div className="w-full lg:w-1/4 md:w-1/4 px-4 mb-8">
                            <div className="footer-links">
                                <h4 className="text-lg font-semibold text-white mb-4 pb-2 relative after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-5 after:h-0.5 after:bg-yellow-500">
                                    Quick Links
                                </h4>
                                <ul className="space-y-3">
                                    {scrollNavItems.map((item) => (
                                        <li key={item.id}>
                                            {isHomePage ? (
                                                <ScrollLink
                                                    to={item.scrollTo}
                                                    smooth={true}
                                                    duration={500}
                                                    className={`cursor-pointer ${linkClass}`}
                                                >
                                                    {item.label}
                                                </ScrollLink>
                                            ) : (
                                                <Link to={item.to} className={linkClass}>
                                                    {item.label}
                                                </Link>
                                            )}
                                        </li>
                                    ))}
                                    <li>
                                        <Link to="/quote" className={linkClass}>
                                            Get Quotation
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/* Legal */}
                        <div className="w-full lg:w-1/4 md:w-1/4 px-4 mb-8">
                            <div className="footer-links">
                                <h4 className="text-lg font-semibold text-white mb-4 pb-2 relative after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-5 after:h-0.5 after:bg-yellow-500">
                                    Legal
                                </h4>
                                <ul className="space-y-3">
                                    <li>
                                        <Link to="/privacy-policy" className={linkClass}>
                                            Privacy Policy
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/terms-of-service" className={linkClass}>
                                            Terms of Service
                                        </Link>
                                    </li>
                                    {['Licenses', 'Compliance'].map((link, index) => (
                                        <li key={index}>
                                            <Link to="#" className={linkClass}>
                                                {link}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="copyright py-8">
                <div className="container mx-auto px-4">
                    <div className="flex flex-col lg:flex-row items-center justify-center lg:justify-between">
                        {/* Copyright Text */}
                        <div className="flex flex-col items-center lg:items-start mb-6 lg:mb-0">
                            <div className="text-gray-400 text-center lg:text-left mb-2">
                                © Copyright <strong className="font-semibold text-white">Alternative Energy</strong>. All Rights Reserved
                            </div>
                            <div className="credits text-gray-500 text-sm text-center lg:text-left">
                                Designed by <Link to="https://james-baker-portfolio-liard.vercel.app" className="text-yellow-500 hover:text-yellow-400 transition-colors duration-300">James Baker</Link>
                                <span className="mx-2">•</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;